import React from 'react';

import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import Modal from '~components/atoms/Modal';
import RegionBaseForm from '../RegionsBaseForm';

import { TCreateNewRegionReduxParams } from '~types/feat/branch';

const RegionsCreateNewRegionModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.branch.modals.createNewRegionModalIsOpen);
    const isLoading = useAppSelector(state => state.branch.loadings.createNewRegion);
    const error = useAppSelector(state => state.branch.errors.createNewRegion);

    const handleModalOnClose = () => {
        dispatch(combinedActions.branchResetCreateNewRegionState());
        dispatch(combinedActions.branchSetCreateNewRegionModalIsOpen(false));
    };

    const handleOnSubmit = (data: TCreateNewRegionReduxParams) => !isLoading && dispatch(combinedActions.branchCreateNewRegionAttempt(data));

    return (
        <Modal
            title='Create Region'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            <RegionBaseForm
                submitButtonLabel='Create Region'
                onSubmit={handleOnSubmit}
                actionButtonIsLoading={isLoading}
                error={error}
            />
        </Modal>
    );
};

export default RegionsCreateNewRegionModal;
